<template>
	<div class="progress-circle">
		<div
			class="progress-circle__chart"
			:height="diameter"
			:width="diameter"
		>
			<svg
				class="progress-circle__ring"
				:height="diameter"
				:width="diameter"
			>
				<circle
					class="progress-circle__circle progress-circle__circle--default"
					:style="{
						stroke: baseBorder,
						fill: backgroundColor,
					}"
					:stroke-width="progressThickness"
					:r="normalizedRadius"
					:cx="radius"
					:cy="radius"
				/>

				<circle
					class="progress-circle__circle"
					stroke-linecap="round"
					:stroke="progressData.progressColor"
					fill="transparent"
					:stroke-dasharray="`${circumference} ${circumference}`"
					:style="{ 'stroke-dashoffset': strokeDashoffset(progressData.progress) }"
					:stroke-width="progressThickness"
					:r="normalizedRadius"
					:cx="radius"
					:cy="radius"
				/>
			</svg>

			<div
				class="progress-circle__inner-text"
				:style="{ fontSize: `${radius * 0.35}px` }"
			>
				<slot />

				<helio-icon
					v-if="iconToken && !hasDefaultSlot"
					:token="iconToken"
					:weight="iconWeight"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProgressCircle',

	props: {
		backgroundColor: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the background color of the main circle.',
		},

		baseBorder: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the border color of the main circle.',
		},

		iconToken: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the icon in the middle of the progress-circle',
		},

		iconWeight: {
			type: String,
			required: false,
			default: 'regular',
			validator: value => [
				'bold',
				'brand',
				'light',
				'regular',
			].indexOf(value) !== -1,
			description: 'Sets the weight of the icon in the middle of the progress-circle',
		},

		progressData: {
			type: Object,
			required: true,
			description: 'Sets the array containing objects describing each circular progression bar and its color.',
		},

		progressThickness: {
			type: Number,
			required: false,
			default: 6,
			description: 'Sets the thickness of the circular progression bar.',
		},

		radius: {
			type: Number,
			required: false,
			default: 132,
			description: 'Sets the radius size of the circle (half the width or height).',
		},
	},

	computed: {
		circumference() {
			return this.normalizedRadius * 2 * Math.PI;
		},

		diameter() {
			return this.radius * 2;
		},

		hasDefaultSlot() {
			return !!this.$slots.default || !!this.$scopedSlots.default;
		},

		normalizedRadius() {
			return this.radius - this.progressThickness * 2;
		},
	},

	methods: {
		strokeDashoffset(progress) {
			return this.circumference - progress / this.progressData.total * this.circumference;
		},
	},
};
</script>

<style scoped lang="scss" src="./progress-circle.scss" />
